// extracted by mini-css-extract-plugin
export default {"socketDisconnectionMessage":"allowOneSocketConnectionContext_socketDisconnectionMessage__cgIrP"};